import shallow from 'zustand/shallow'
import useStore from '../store/useStore'

export default () =>
  useStore(state => state.firestoreUser?.profile, shallow)
